import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from 'src/environments/environment';
import {Router} from '@angular/router';
import {RxAuthService} from '../rx-auth/rx-auth.service';

@Injectable({
  providedIn: 'root',
})
export class ListsService {
  private apiUrl = `${environment.backend_base}main/lists`;

  constructor(
    private http: HttpClient,
    private router: Router,
    private auth: RxAuthService
  ) {
  }

  // Create a new list
  createList(name: string, description: string): Observable<any> {
    const body = {name: name, description: description}; // Include both name and description in the body
    return this.http.post<any>(
      `${this.apiUrl}/create/`,
      body,
      this.auth.httpOptions
    );
  }

  // Delete a list
  deleteList(listId: number): Observable<any> {
    const body = {list_id: listId};
    return this.http.post<any>(
      `${this.apiUrl}/delete/`,
      body,
      this.auth.httpOptions
    );
  }

  // Rename an existing list
  renameList(listId: number, newName: string): Observable<any> {
    const body = {list_id: listId, new_name: newName};
    return this.http.post<any>(
      `${this.apiUrl}/rename/`,
      body,
      this.auth.httpOptions
    );
  }

  // Get all user lists
  getAllUserLists(): Observable<any> {
    return this.http.post<any>(
      `${this.apiUrl}/get_user_lists/`,
      {},
      this.auth.httpOptions
    );
  }

  // Get all visualizations in a list
  getAllVisualizationsInList(listId: number): Observable<any> {
    const body = {list_id: listId};
    return this.http.post<any>(
      `${this.apiUrl}/get_visualizations_in_list/`,
      body,
      this.auth.httpOptions
    );
  }

  isVisualizationSaved(chartId: number | null, rclId: number| null, customChartJson: any | null, sqaID:any | null): Observable<any> {
    const body = {chart_id: chartId, rcl_id: rclId, custom_data: customChartJson, sqa_chart_id: sqaID};
    return this.http.post<any>(
      `${this.apiUrl}/is_visualization_saved/`,
      body,
      this.auth.httpOptions
    );
  }

  shareList(
    listID: number,
    email: string,
    email_web_link_domain: string,
    editor_permission: boolean
  ): Observable<any> {
    const body = {
      list_id: listID,
      email: email,
      email_web_link_domain: email_web_link_domain,
      editor_permission: editor_permission,
    }; // Include both name and description in the body
    return this.http.post<any>(
      `${this.apiUrl}/share/`,
      body,
      this.auth.httpOptions
    );
  }

  unShareList(listID: number, email: string): Observable<any> {
    const body = {list_id: listID, email: email}; // Include both name and description in the body
    return this.http.post<any>(
      `${this.apiUrl}/unshare/`,
      body,
      this.auth.httpOptions
    );
  }

  addVisualizationToList(
    listID: number,
    visID: number | null,
    rclID: number | null,
    chartID: string | null,
    stateJson: string | null,
    sqaChartID: number|null,
  ): Observable<any> {
    const body = {list_id: listID, vis_id: visID, rcl_id: rclID, chart_id: chartID, custom_data: stateJson, sqa_chart_id: sqaChartID};
    return this.http.post<any>(
      `${this.apiUrl}/add_visualization/`,
      body,
      this.auth.httpOptions
    );
  }

  removeVisualizationFromList(
    listID: number,
    visID: number | null,
    rclID: number |null,
    customData: string|null,
    sqaChartID: number|null,
  ): Observable<any> {
    const body = {list_id: listID, vis_id: visID, rcl_id: rclID, custom_data: customData, sqa_chart_id: sqaChartID};
    return this.http.post<any>(
      `${this.apiUrl}/remove_visualization/`,
      body,
      this.auth.httpOptions
    );
  }

  saveCustomTextElements(listId: number, visualization:any , newTextElements: any ): Observable<any> {
    const body = {list_id: listId, visualization: visualization,  new_text_elements: newTextElements};
    return this.http.post<any>(
      `${this.apiUrl}/save_custom_text_elements/`,
      body,
      this.auth.httpOptions
    );
  }

  saveVisualizationsInListOrder(listId: number, visualizations:any): Observable<any> {
    const body = {list_id: listId, visualizations: visualizations,};
    return this.http.post<any>(
      `${this.apiUrl}/save_visualizations_in_list_order/`,
      body,
      this.auth.httpOptions
    );
  }
}
